var ua_analytics = new Array();
ua_analytics['loquillo'] = "G-CZVJQPQLBB";
ua_analytics['fito-y-fitipaldis'] = "G-9WNLNZGRSS";
ua_analytics['tarque'] = "G-FCM24KJ9KF";
ua_analytics['la-polla-records'] = "G-RNTMHQYNCV";
ua_analytics['los-suaves'] = "G-NBYM75JFMR";
ua_analytics['m-clan'] = "G-Q58NWZ0TEN";
ua_analytics['quique-gonzalez'] = "G-PZRBYNESNH";
ua_analytics['metales-preciosos'] = "G-RQSNCMJ22R";
ua_analytics['los-secretos'] = "G-NZLCX1MJH7";
ua_analytics['los-zigarros'] = "G-K1DTGYWW86";
ua_analytics['morgan'] = 'G-4J6PSFPXQR';
ua_analytics['ixo-rai'] = 'G-0W26KSTGQW';
ua_analytics['uoho'] = 'G-TYDCVYVDZS';
ua_analytics['rocktud'] = 'G-6EY34098P2';
ua_analytics['belako'] = 'G-3W15110SFR';
ua_analytics['sweet-california'] = 'G-WV9XY621FC';
ua_analytics['billy-boom-band'] = 'G-5TPKNB8WCX';
ua_analytics['kiko-veneno'] = 'G-0LQK5W02VF';
ua_analytics['duo-dinamico'] = 'G-PQ11P3MB73';
ua_analytics['paco-candela'] = 'G-4DQGSD2NV7';
ua_analytics['marta-sanchez'] = 'G-S0E4D95NML';
ua_analytics['ramoncin'] = 'G-L4CQP7J0G5';
ua_analytics['lorreine'] = 'G-8JC33N3366';
ua_analytics['idoia-asurmendi'] = 'G-ZB5WGSNCNL';
ua_analytics['el-cigala'] = 'G-LCKBRSZ8BF';
ua_analytics['we-are-mono'] = 'G-H3HNDWZJWV';
ua_analytics['marisa-valle-roso'] = 'G-61HV8T147Q';
ua_analytics['miren'] = 'G-VW9TZ8GXZX';
ua_analytics['fondo-flamenco'] = 'G-0GPVD5ZTDB';
ua_analytics['janus-lester'] = 'G-MK5ZG6RD18';



/* AQUI VAN LOS IDs DEL PIXEL DE FACEBOOK. SI NO SE DEFINE NO SALDRÁ */
var pixel_facebook = new Array();
pixel_facebook['belako'] = '312531292667198';
pixel_facebook['la-polla-records'] = '469116477267092';
pixel_facebook['fito-y-fitipaldis'] = '516726866385326';
pixel_facebook['paco-candela'] = '287901039044107';
pixel_facebook['sweet-california'] = '437757936905509';

